import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkleAi = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.8333 8.2939C20.0552 7.7476 20.8287 7.7476 21.0506 8.2939L22.7133 12.3875C23.7812 15.0169 25.8671 17.1028 28.4966 18.1708L32.5901 19.8334C33.1365 20.0553 33.1365 20.8288 32.5901 21.0508L28.4966 22.7134C25.8671 23.7813 23.7812 25.8672 22.7133 28.4966L21.0506 32.5903C20.8287 33.1366 20.0552 33.1366 19.8333 32.5903L18.1706 28.4966C17.1027 25.8672 15.0168 23.7813 12.3874 22.7134L8.2938 21.0508C7.7475 20.8288 7.7475 20.0553 8.2938 19.8334L12.3874 18.1708C15.0168 17.1028 17.1027 15.0169 18.1706 12.3875L19.8333 8.2939Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.4506 9.415C12.1405 9.2821 11.8934 9.035 11.7605 8.7249L11.1918 7.3979C10.9642 6.8669 10.2116 6.8669 9.9841 7.3979L9.4153 8.7249C9.2824 9.035 9.0353 9.2821 8.7252 9.415L7.3982 9.9838C6.8673 10.2113 6.8673 10.9639 7.3982 11.1914L8.7252 11.7602C9.0353 11.8931 9.2824 12.1402 9.4153 12.4503L9.9841 13.7774C10.2116 14.3083 10.9642 14.3083 11.1918 13.7774L11.7605 12.4503C11.8934 12.1402 12.1405 11.8931 12.4506 11.7602L13.7777 11.1914C14.3086 10.9639 14.3086 10.2113 13.7777 9.9838L12.4506 9.415Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSparkleAi);
export default ForwardRef;
